import { Reducer } from "redux";
import { SideBarActionTypes } from "./types";
import { SideBarActionKeys } from "./keys";
import { IDashboardMenu, IDashboardMenuCalloutUpdate } from "models/AppModels";
import { GenieActionTypes } from "store/genie/types";
import { GenieActionKeys } from "store/genie/keys";
import { NotificationCalloutDto } from "models/ApiModels";
import { RoutePaths } from "routes/RouteConfig";
import { FeedType, DynamicSystemRoles } from "models/ApiEnums";
import { AppActionKeys } from "store/app/keys";
import { AppActionTypes } from "store/app/types";
import Session from "services/Session";

//////////////////////////////////////////////////////////////////////////////////////

export interface SideBarState {
    readonly menuData: IDashboardMenu[];
}

const initialState: SideBarState = {
    menuData: []
};

//////////////////////////////////////////////////////////////////////////////////////

function translateCalloutsToSidebar(data: NotificationCalloutDto[]): IDashboardMenuCalloutUpdate[] {
    var list: IDashboardMenuCalloutUpdate[] = [];

    data.forEach(d => {

        switch (d.feed) {
            case FeedType.QuestionFollowing:
            case FeedType.QuestionToYou:
                list.push({
                    path: RoutePaths.TimelineQuestions,
                    callout: data.filter(p => (p.feed == FeedType.QuestionFollowing || p.feed == FeedType.QuestionToYou) && p.callout).length > 0
                });
                break;

            case FeedType.Following:
                list.push({
                    path: RoutePaths.TimelineFollowing,
                    callout: data.filter(p => p.feed == FeedType.Following && p.callout).length > 0
                });
                break;

            case FeedType.TaskForYourAction:
            case FeedType.TaskForYourApproval:
            case FeedType.TaskDenouncement:
                list.push({
                    path: RoutePaths.TimelineActions,
                    callout: data.filter(p => (p.feed == FeedType.TaskForYourAction || p.feed == FeedType.TaskForYourApproval || p.feed == FeedType.TaskDenouncement) && p.callout).length > 0
                });
                break;

            case FeedType.MyPublication:
                list.push({
                    path: RoutePaths.TimelinePublications,
                    callout: data.filter(p => p.feed == FeedType.MyPublication && p.callout).length > 0
                });
                break;

            case FeedType.CourseEnrolled:
                list.push({
                    path: RoutePaths.TimelineCourses,
                    callout: data.filter(p => p.feed == FeedType.CourseEnrolled && p.callout).length > 0
                });
                break;

            case FeedType.Topic:
                data.filter(p => p.feed == FeedType.Topic && p.topicId)
                    .forEach((v) => {
                        list.push({
                            path: RoutePaths.TimelineTopic.replace(":id", v.topicId),
                            callout: v.callout
                        });
                    });
                break;
        }
    });

    return list;
}

//////////////////////////////////////////////////////////////////////////////////////


const sidebarReducer: Reducer<SideBarState, SideBarActionTypes> = (state = initialState, action: SideBarActionTypes | GenieActionTypes | AppActionTypes) => {
    switch (action.type) {
        case GenieActionKeys.INIT:
            return { menuData: [] };

        case AppActionKeys.CALLOUTS: {
            var sidebarCallouts = translateCalloutsToSidebar(action.payload);
            const data = state.menuData.slice(0);

            for (var i = 0; i < data.length; i++) {

                for (let p = 0; p < sidebarCallouts.length; p++) {
                    if (data[i].navbarPath == sidebarCallouts[p].path) {
                        data[i].callout = sidebarCallouts[p].callout;
                    }
                }

                for (let j = 0; j < data[i].groups.length; j++) {

                    var items = data[i].groups[j].items;
                    if (items) {
                        for (let k = 0; k < items.length; k++) {
                            for (let p = 0; p < sidebarCallouts.length; p++) {
                                if (items[k].path == sidebarCallouts[p].path) {
                                    items[k].callout = sidebarCallouts[p].callout;
                                }
                            }
                        }
                    }

                }
            }

            // Se o usuário passou a realizar cursos, atualiza essa informação na Sessão.
            if (action.payload.filter(p => p.feed == FeedType.CourseEnrolled && p.callout).length > 0) {
                if (Session.hasDynamicRole(DynamicSystemRoles.HasOrCanViewCourses) == false) {
                    Session.updateHasOrCanViewCourses(true);
                }
            }

            return { menuData: data };
        }

        case SideBarActionKeys.SIDEBAR_UPDATE_DATA:
            return { menuData: action.payload };


        case SideBarActionKeys.SIDEBAR_CHANGE_NAME:
            {
                const data = state.menuData.slice(0);
                let found = false;

                for (let i = 0; i < data.length && !found; i++) {
                    for (let j = 0; j < data[i].groups.length && !found; j++) {
                        if (data[i].groups[j].items) {
                            for (let k = 0; k < data[i].groups[j].items.length && !found; k++) {
                                if (data[i].groups[j].items[k].path == action.payload.path) {
                                    data[i].groups[j].items[k].name = action.payload.newName;
                                    found = true;
                                }
                            }
                        }
                    }
                }

                return { menuData: data };
            }

        case SideBarActionKeys.SIDEBAR_UPDATE_GROUP_SHOWED_ITEMS:
            {
                const data = state.menuData.slice(0);
                let found = false;

                for (let i = 0; i < data.length && !found; i++) {
                    for (let j = 0; j < data[i].groups.length && !found; j++) {
                        if (data[i].groups[j].group == action.payload.group) {
                            data[i].groups[j].listCurrentIndex = action.payload.newShowedItems;
                            found = true;
                        }
                    }
                }

                return { menuData: data };
            }

        default:
            return state;
    }
};

export { sidebarReducer };